var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6555_5650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6211 17.5698H16.6211V19.0698H10.6211V17.5698Z",
    fill: "#7F8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62109 17.5698H9.12109V19.0698H7.62109V17.5698Z",
    fill: "#7F8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6211 13.8198H16.6211V15.3198H10.6211V13.8198Z",
    fill: "#7F8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62109 13.8198H9.12109V15.3198H7.62109V13.8198Z",
    fill: "#7F8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6211 10.0698H16.6211V11.5698H10.6211V10.0698Z",
    fill: "#7F8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62109 10.0698H9.12109V11.5698H7.62109V10.0698Z",
    fill: "#7F8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8711 4.06982H16.6211V3.31982C16.6211 2.922 16.4631 2.54047 16.1818 2.25916C15.9004 1.97786 15.5189 1.81982 15.1211 1.81982H9.12109C8.72327 1.81982 8.34174 1.97786 8.06043 2.25916C7.77913 2.54047 7.62109 2.922 7.62109 3.31982V4.06982H5.37109C4.97327 4.06982 4.59174 4.22786 4.31043 4.50916C4.02913 4.79047 3.87109 5.172 3.87109 5.56982V21.3198C3.87109 21.7176 4.02913 22.0992 4.31043 22.3805C4.59174 22.6618 4.97327 22.8198 5.37109 22.8198H18.8711C19.2689 22.8198 19.6504 22.6618 19.9318 22.3805C20.2131 22.0992 20.3711 21.7176 20.3711 21.3198V5.56982C20.3711 5.172 20.2131 4.79047 19.9318 4.50916C19.6504 4.22786 19.2689 4.06982 18.8711 4.06982ZM9.12109 3.31982H15.1211V6.31982H9.12109V3.31982ZM18.8711 21.3198H5.37109V5.56982H7.62109V7.81982H16.6211V5.56982H18.8711V21.3198Z",
    fill: "#7F8594"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6555_5650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.121094 0.319824)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/task-icon.41824e4695ccea5f136bf12b81b1cdb5.svg";
export { ForwardRef as ReactComponent };